import React, { FC, useState } from 'react';

import './CancelContract.scss';
import TemplateModal from 'components/common/modals/TemplateModal';
import Button from 'components/common/ui-kit/Button';
import useAppDispatch from 'hooks/common/useAppDispatch';
import useAppSelector from 'hooks/common/useAppSelector';
import useModeratorContractIdInfoForm from 'hooks/moderator/useModeratorContractIdInfoForm';
import { createToast, hideModal } from 'redux/actions';
import { modalDataSelector } from 'redux/selectors';

const CancelContract: FC = () => {
  const { cancel } = useModeratorContractIdInfoForm();
  const dispatch = useAppDispatch();
  const { contractId } = useAppSelector(modalDataSelector);
  const closeModal = () => dispatch(hideModal());
  const [isLoading, setIsLoading] = useState(false);
  const handleSave = () => {
    if (isLoading) return;
    setIsLoading(true);
    cancel(contractId)
      .then(() => {
        closeModal();
      })
      .catch(error => {
        dispatch(createToast(error.data.message, 'danger'));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  return (
    <TemplateModal title="Аннулирование договора">
      <div className="cancel-contract-modal">
        <div className="row">Вы уверены, что хотите аннулировать договор?</div>
        <div className="btn-group">
          <Button disabled={isLoading} theme="success" onClick={handleSave}>
            Да
          </Button>
          <Button disabled={isLoading} onClick={closeModal}>
            Нет
          </Button>
        </div>
      </div>
    </TemplateModal>
  );
};

export default CancelContract;
